import React from 'react';
import {Link} from "react-router-dom";
import logo from '../logo1.svg'

function Navbar(props) {
    return (
        <nav className='navbar'>
            <div className="nav-center">
                <Link to='/'>
                    <img src={logo} alt='#' className='logo'/>
                </Link>
            </div>
            <ul className='nav-links'>
                <li>
                    <Link to='/home'>
                        Home
                    </Link>
                </li>
                <li>
                    <Link to='about'>
                        About
                    </Link>
                </li>
            </ul>
        </nav>
    );
}

export default Navbar;